import React from 'react';
import Link from 'next/link';
import { Article } from '@/types/Blog';

interface ArticleCardProps {
  article: Article;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ article }) => {
  const shortDesc = article.shortDescription.split(' ').slice(0, 10).join(' ');

  return (
    <div className=" h-80 md:h-96 w-full md:pr-0 mb-10">

      <Link href={`/iit-news/${article.slug}`}>
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-48 md:h-56 lg:h-64 object-cover rounded"
        />
        <div className="p-2">
          <h3 className="font-semibold text-defaultBlue text">{article.category}</h3>
          <h3 className="font-semibold md:text-lg mt-1 line-clamp-1">
            {article.title}
          </h3>
          <span className="text-gray-500 text-sm">{article.time} | {article.date}</span>
          <p className="mt-2 text-justify text-gray-500  line-clamp-2">
            {shortDesc} (...)
          </p>
        </div>
      </Link>
    </div>
  );
};

export default ArticleCard;